import * as TYPES from '../../store/types'

const state = {
  roles: [],
  metadata: {},
  readOnly: false,
}

/* eslint-disable no-param-reassign */
const mutations = {
  [TYPES.ROLES_SET_DATA](st, obj) {
    if (obj.roles) {
      st.roles = obj.roles
    }

    if (obj.metadata) {
      st.metadata = obj.metadata
    }

    st.readOnly = !!obj.readOnly
  },
}

const actions = {
  rolesSetData({ commit }, obj) {
    commit(TYPES.ROLES_SET_DATA, obj)
  },
}

const module = {
  state,
  mutations,
  actions,
}

export default { module }
